// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"c2f9a020","172":"afecbdb1","201":"6a0c793f","210":"1c2b9daa","225":"8d42b0a8","303":"24c54a97","423":"c0d474d8","494":"4ed87280","803":"cd67b85e"}[chunkId] + ".chunk.css";
};